/* Iceberg UI */
import { Box, Button, IconWithVariant } from '@auviknetworks/iceberg-ui';
import { SessionHelper } from 'application/Shared/Helpers';
import { useSession } from 'hooks/redux/Selectors/session';
import React from 'react';

interface DisableButtonProps {
    email: string;
    onClick: () => void;
}

/**
 * DisableButton Component
 *
 * A button component that renders an icon button used to disable user accounts.
 * The button is automatically disabled if the target email matches the current user's email,
 * preventing users from disabling their own accounts.
 *
 * @returns {JSX.Element} A disabled-styled icon button component
 */
export const DisableButton = ({ email, onClick }: DisableButtonProps) => {
    const session = useSession();
    const sessionHelper = new SessionHelper(session);
    const user = sessionHelper.getUser();
    // We don't allow to dissabling the current user
    const isDisabled = user.email === email;

    return (
        <Box width="100%">
            <Button
                disabled={isDisabled}
                onClick={onClick}
                size="icon"
                variant="iconWithoutBorder"
            >
                <IconWithVariant
                    src="NoUserAccount"
                    variant={isDisabled ? 'grey' : 'danger'}
                />
            </Button>
        </Box>
    );
};
